import { ScheduleType } from "./scheduled-event-emitter.types";
import { SessionStorage } from "../../../../adblockpluschrome/lib/storage/session";
const global = typeof window !== "undefined" ? window : self;
const storageKey = "schedules";
const storage = new SessionStorage("ScheduledEventEmitter.storage");
const initialization = initialize();
let schedules = Object.create(null);
const listeners = new Map();
export async function setListener(name, listener) {
    await initialization;
    if (listeners.has(name)) {
        warn(`Overwriting already registered listener for event "${name}".`);
    }
    listeners.set(name, listener);
    activateSchedules();
}
export async function setSchedule(name, time, scheduleType = ScheduleType.once) {
    await initialization;
    if (name in schedules) {
        warn(`Overwriting already registered schedule for name "${name}".`);
    }
    schedules[name] = {
        period: time,
        next: time + Date.now(),
        runOnce: scheduleType === ScheduleType.once,
        count: 0,
    };
    await persistSchedules();
    activateSchedules();
}
export async function removeSchedule(name) {
    await initialization;
    const schedule = schedules[name];
    if (!schedule) {
        return;
    }
    if (schedule.runOnce) {
        global.clearTimeout(schedule.activationId);
    }
    else {
        global.clearInterval(schedule.activationId);
    }
    delete schedules[name];
    await persistSchedules();
}
export async function removeListener(name) {
    await initialization;
    listeners.delete(name);
}
async function initialize() {
    await reviveSchedules();
}
async function persistSchedules() {
    await storage.set(storageKey, schedules);
}
async function reviveSchedules() {
    const storedSchedules = await storage.get(storageKey);
    if (Object.prototype.toString.call(storedSchedules) !== "[object Object]") {
        warn("Could not restore stored schedules.");
        return;
    }
    schedules = storedSchedules;
    Object.keys(schedules).forEach((name) => {
        delete schedules[name].activationId;
    });
}
function activateSchedules() {
    const now = Date.now();
    Object.entries(schedules).forEach(([name, schedule]) => {
        const delta = schedule.next - now;
        const isDue = delta <= 0;
        const activationKey = "activationId";
        if (activationKey in schedule) {
            return;
        }
        if (!schedule.runOnce) {
            schedule.activationId = global.setInterval(() => emitEvent(name), schedule.period);
            return;
        }
        if (!isDue) {
            schedule.activationId = global.setTimeout(() => emitEvent(name), delta);
            return;
        }
        emitEvent(name);
    });
}
async function emitEvent(name) {
    const schedule = schedules[name];
    const listener = listeners.get(name);
    if (!schedule || !listener) {
        return;
    }
    schedule.count += 1;
    const now = Date.now();
    const callCount = schedule.count;
    listener({ callCount });
    if (schedule.runOnce) {
        await removeSchedule(name);
    }
    else {
        schedule.next = now + schedule.period;
        await persistSchedules();
    }
}
function warn(message) {
    console.warn(`[ScheduledEventEmitter]: ${message}`);
}
